import React, { useState, useContext, useEffect, createRef } from "react";
import EventContext from "./eventContext";
import FirebaseContext from "../firebase/firebaseContext";
import { v4 as uuidv4 } from "uuid";

const EventState = props => {
  const [event, setEvent] = useState([{}]);
  const [homework, setHomework] = useState(null);
  const [filteredEvents, setFilteredEvents] = useState();
  const [filterOn, setFilterOn] = useState(false);
  const firebaseContext = useContext(FirebaseContext);
  const [exercises, setExercises] = useState(null);
  const { auth, db } = firebaseContext;
  const [circle, setCircle] = useState({
    isBlue: false,
    isPurple: false,
    isGreen: false
  });

  const circleFunction = choice => {
    setCircle(choice);
  };
  const addExercise = newEvent => {
    auth.onAuthStateChanged(user => {
      if (user) {
        const exercises = db.collection("exercises");

        exercises.add({
          id: uuidv4(),
          ytLink: newEvent.ytLink,
          ytLinkInfo: newEvent.ytLinkInfo,
          lesson: newEvent.lesson,
          lessonClassName: newEvent.lessonClassName,
          lessonTitle: newEvent.lessonTitle,
          lessonPartOneSrc: newEvent.lessonPartOneSrc,
          lessonLinkOne: newEvent.lessonLinkOne,

          lessonLinkTwo: newEvent.lessonLinkTwo,
          lessonLinkThree: newEvent.lessonLinkThree,
          lessonLinkFour: newEvent.lessonLinkFour,
          lessonLinkOneInfo: newEvent.lessonLinkOneInfo,
          lessonLinkTwoInfo: newEvent.lessonLinkTwoInfo,
          lessonLinkThreeInfo: newEvent.lessonLinkThreeInfo,

          lessonLinkFourInfo: newEvent.lessonLinkFourInfo,
          pdfSrc: newEvent.pdfSrc,
          pdfInfo: newEvent.pdfInfo,
          lessonPartOneInstructions: newEvent.lessonPartOneInstructions,
          lessonInstructionsOne: newEvent.lessonInstructionsOne
        });
      }
    });
  };
  const addEvent = newEvent => {
    auth.onAuthStateChanged(user => {
      if (user) {
        const events = db.collection("events");

        events.add({
          id: uuidv4(),
          isBlue: circle.isBlue,
          isPurple: circle.isPurple,
          isGreen: circle.isGreen,
          lesson: newEvent.lesson,
          ytLink: newEvent.ytLink,
          ytLinkInfo: newEvent.ytLinkInfo,
          lessonTitle: newEvent.lessonTitle,
          lessonDate: newEvent.lessonDate,
          lessonClassName: newEvent.lessonClassName,
          lessonInstructionsOne: newEvent.lessonInstructionsOne,
          lessonInstructionsTwo: newEvent.lessonInstructionsTwo,
          lessonHomeworkOne: newEvent.lessonHomeworkOne,
          lessonHomeworkTwo: newEvent.lessonHomeworkTwo,
          lessonHomeworkThree: newEvent.lessonHomeworkThree,
          lessonPartOneInstructions: newEvent.lessonPartOneInstructions,
          lessonPartTwoInstructions: newEvent.lessonPartTwoInstructions,
          lessonPartThreeInstructions: newEvent.lessonPartThreeInstructions,
          lessonPartFourInstructions: newEvent.lessonPartFourInstructions,
          lessonPartOneSrc: newEvent.lessonPartOneSrc,
          lessonPartTwoSrc: newEvent.lessonPartTwoSrc,
          lessonPartThreeSrc: newEvent.lessonPartThreeSrc,
          lessonPartFourSrc: newEvent.lessonPartFourSrc,
          pdfSrc: newEvent.pdfSrc,
          pdfInfo: newEvent.pdfInfo,
          lessonLinkOne: newEvent.lessonLinkOne,

          lessonLinkTwo: newEvent.lessonLinkTwo,
          lessonLinkThree: newEvent.lessonLinkThree,
          lessonLinkFour: newEvent.lessonLinkFour,
          lessonLinkOneInfo: newEvent.lessonLinkOneInfo,
          lessonLinkTwoInfo: newEvent.lessonLinkTwoInfo,
          lessonLinkThreeInfo: newEvent.lessonLinkThreeInfo,

          lessonLinkFourInfo: newEvent.lessonLinkFourInfo
        });
      }
    });
  };

  const filterList = grade => {
    const homeworks = db.collection("events");
    homeworks.where("lessonClassName", "==", grade).onSnapshot(snapshot => {
      if (!snapshot) {
        setHomework(l => []);
      } else {
        let homeworkList = [];
        snapshot.forEach(hw => {
          homeworkList.push({ ...hw.data() });
        });
        setHomework(l => homeworkList);
      }
    });
  };
  const filterExercises = grade => {
    const exercises = db.collection("exercises");
    exercises.where("lessonClassName", "==", grade).onSnapshot(snapshot => {
      if (!snapshot) {
        setExercises(l => []);
      } else {
        let exerciseList = [];
        snapshot.forEach(exercise => {
          exerciseList.push({ ...exercise.data() });
        });
        setExercises(l => exerciseList);
      }
    });
  };

  const newRef = createRef();

  const scrollTo = () => {
    newRef.current.scrollIntoView({ beahvior: "smooth" });
  };

  return (
    <EventContext.Provider
      value={{
        event,
        addEvent,
        setEvent,
        homework,

        filteredEvents,
        filterOn,
        newRef,
        scrollTo,
        filterList,
        addExercise,
        exercises,
        filterExercises,
        circle,
        circleFunction,
        setCircle
      }}
    >
      {props.children}
    </EventContext.Provider>
  );
};

export default EventState;
